var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"linked-pages-list"},_vm._l((_vm.items),function(page,index){return _c('html-link',{key:index + page.code,staticClass:"linked-pages-list__link",attrs:{"url":page.htmlUrl}},[_vm._v("\n        "+_vm._s(page.name)+"\n    ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }